
import Contact from "./Pages/Contact";
import Header from "./Pages/Header";
import Resume from "./Pages/Resume";
import Skills from "./Pages/Skills";




function App() {
  return (
    <div>
    
      <Header/>
      <Skills/>
      <Contact/>
      <Resume/>
    </div>
  );
}

export default App;
